import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class RobotService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/chatbot-server/api'
  };
  // 获取机器人列表
  getList(data: any) {
    return this.get('/bots', data);
  }
  // 新增机器人
  addRobot(data: any) {
    return this.post('/bots', data);
  }
  // 编辑机器人
  editRobot(bot_id: any, data: any) {
    return this.put(`/bots/${bot_id}`, data);
  }
  // 删除机器人
  deleteRobot(bot_id: any) {
    return this.delete(`/bots/${bot_id}`);
  }
  // 启用禁用机器人
  statusChangeRobot(bot_id: any) {
    return this.delete(`/bots/${bot_id}`);
  }
  // 发布机器人
  publishRobot(botId: any) {
    return this.post(`bots/publish/${botId}`);
  }
}
export default new RobotService();
